module.exports = __webpack_public_path__ + "static/bg_HeroDashboard-365e26037701d1fa125db1362983686f.jpg";